export const steps = {
    intro: 1,
    copyFeedUrl: 2,
    feedUrl: 3,
    showInformation: 4,
};
